import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class BackButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.appNavigation.backButtonTooltip} >
			<i className="icon--menu">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="30 30 19.11 16 30 2 24.93 2 14.04 16 24.93 30 30 30" />
					<polygon points="19.96 30 9.07 16 19.96 2 14.89 2 4 16 14.89 30 19.96 30" />
				</svg>
			</i>
		</Button>;
	}
}
